export default __webpack_public_path__ + "static/chocpops-taste-3-mobile-c5d240f2ca5308e7183994a1176883db.png";